module.exports = __webpack_public_path__ + "img/icon-filter.ead5314f.svg";